<i18n>
{
  "ru": {
    "transaction_rrn": "RRN транзакции",
    "order_num": "Номер заказа",
    "card": "Карта",
    "card_type": "Тип карты",
    "card_level": "Уровень карты",
    "bank_country": "Страна банка получателя",
    "issuer": "Банк-эмитент"
  },
  "en": {
    "transaction_rrn": "Transaction RRN",
    "order_num": "Order number",
    "card": "Card",
    "card_type": "Card type",
    "card_level": "Card level",
    "bank_country": "Bank country",
    "issuer": "Issuing bank"
  }
}
</i18n>
<template>
  <div style="margin: auto;max-width: 1175px;">
    <el-card>
      <el-form
        :model="filter"
        ref="searchForm"
        @submit.native.prevent="search"
        :rules="filterRules"
      >
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="7">
            <el-form-item prop="time">
              <el-date-picker
                v-model="filter.time"
                type="daterange"
                range-separator="|"
                :unlink-panels="true"
                :start-placeholder="$t('from')"
                :end-placeholder="$t('to')"
                align="right"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :sm="5">
            <el-form-item prop="payment_status">
              <el-select v-model="filter.payment_status" clearable :placeholder="$t('status')">
                <el-option v-for="(label, key) in statuses" :key="key" :label="label" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="2" class="aligner right" style="height: 60px">
            <el-button native-type="submit" size="small" round type="primary">{{$t('search')}}</el-button>
          </el-col>
          <el-col :sm="3" class="aligner right" style="height: 60px">
            <el-button :disabled="!csvUrl" @click="csvUTF()" size="small" round>CSV (utf-8)</el-button>
          </el-col>
          <el-col :sm="3" class="aligner right" style="height: 60px">
            <el-button :disabled="!csvCPUrl" @click="csvCP()" size="small" round>CSV (cp1251)</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-table
          show-summary
          :summary-method="getSummaries"
          ref="table"
          class="small"
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column prop="date" width="100" :label="$t('batch_date')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.date }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sum" width="110" :label="$t('field_amount')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.sum }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rrn" width="110" :label="$t('transaction_rrn')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.rrn ? scope.row.rrn : scope.row.trimSenderPan }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bin" width="60" label="Bin">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.bin }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="order_num" width="100" :label="$t('order_num')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.order_num }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="trimPan" width="120" :label="$t('card')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.trimPan }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bank" width="100" :label="$t('issuer')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.bank }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardType" width="80" :label="$t('card_type')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.cardType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cardLevel" width="110" :label="$t('card_level')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.cardLevel }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bankCountry" min-width="170" :label="$t('bank_country')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.bankCountry }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>-->
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'bankReports',
  data: () => ({
    filter: {
      // sort_field: 'i_date_orig_format',
      // sort_type: 'DESC',
      time: [],
      currency_id: null,
      payment_status: null
      // page: 1
    },
    filterRules: {
      time: { required: true, trigger: 'blur', message: ' ' }
    },

    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },

    tableData: [],
    totalAmount: null,
    statuses: [],
    csvCPUrl: '',
    csvUrl: '',
    loading: false
  }),
  created() {
    apiRes.get(apiRes.bankReports).then(res => {
      res = res.page_vars
      this.statuses = res.select_payment_status
    }).finally(() => { this.loading = false })
  },
  methods: {
    getSummaries(param) {
      return ['Всего', this.totalAmount]
    },
    search() {
      this.filter.page = 1
      this.loadReports()
    },
    csvUTF() {
      // var content = this.getCsvContent()
      // var encodedUri = encodeURI(content)
      // var link = document.createElement('a')
      // link.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      // link.click()
      // link.remove()

      var link = document.createElement('a')
      link.setAttribute('href', apiRes.baseUrl + this.csvUrl)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      link.click()
      link.remove()
    },
    csvCP() {
      var link = document.createElement('a')
      link.setAttribute('href', apiRes.baseUrl + this.csvCPUrl)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      link.click()
      link.remove()
    },
    getCsvContent() {
      let table = this.$refs['table']
      return [table.columns.map(c => c.label).join(' ;')]
        .concat(table.data.map(row => table.columns.map(c => row[c.property]).join(';'))).join('\n')
    },
    processResponse(vars) {
      if (vars) {
        // vars.res.records.forEach(r => {
        //   if (r.date_last) {
        //     r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$locale)
        //   }
        //   if (r.date_orig) {
        //     r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
        //   }
        //   r.show = false
        // })

        this.csvCPUrl = vars.url_export_csv_cp1251
        this.csvUrl = vars.url_export_csv
        this.tableData = Object.keys(vars.tr).map(k => vars.tr[k])
        this.totalAmount = vars.total_amt
        // this.pagination = {
        //   total: vars.count,
        //   currentPage: vars.page,
        //   pageSize: vars.count_per_page
        // }
      } else {
        this.tableData = []
        // this.pagination = {}
      }
    },
    parseReports(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadReports() {
      this.$refs['searchForm'].validate((valid) => {
        if (this.filter.time && this.filter.time.length === 2) {
          this.loading = true
          const request = {}

          const parts = this.filter.time.map(d => d.toISOString().slice(0, 10))
          request.date_from = parts[0]
          request.date_to = parts[1]
          request.payment_status = this.filter.payment_status
          this.parseReports(apiRes.post(apiRes.bankReports, request))
        }
      })
    },
    changePage(newPage) {
      // this.filter.page = newPage
      // this.loadReports()
    },
    changeSort({ column, prop, order }) {
      // this.filter.sort_field = prop
      // this.filter.sort_type = order === 'ascending' ? 'ASC' : 'DESC'
      // this.loadReports()
    }
  }
}
</script>
<style>
.el-table__footer-wrapper {
  font-weight: bold;
}
.el-table__footer-wrapper tr td:first-child .cell {
  text-align: left;
}
</style>
